import { render, staticRenderFns } from "./wxVirtual.vue?vue&type=template&id=5f27f50a&"
import script from "./wxVirtual.vue?vue&type=script&lang=js&"
export * from "./wxVirtual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports